import React from 'react'
import MessageUI from './MessageUI'
import './Badge.css'

const BadgeUI = ({className, messageList, labelKey, label}) =>
  <div className={`w_badge ${className ? className : ''}`}>
    {
      label &&
      <span>{label}</span>
    }
    {
      labelKey &&
      <MessageUI messageList={messageList} messageKey={labelKey} />
    }
  </div>

export default BadgeUI
